var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B2D8B458-058D-4A28-9B1C-177486591457") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Save-progress",
    transform: "translate(-94.000000, -5.000000)",
    fill: "#3FAD93",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    transform: "translate(94.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67564,6.08744 C8.17564,6.08744 7.76782,5.67962 7.76782,5.17962 L7.76782,0.90782 C7.76782,0.40782 8.17564,2.22044605e-13 8.67564,2.22044605e-13 C9.17564,2.22044605e-13 9.58346,0.40782 9.58346,0.90782 L9.58346,5.17582 C9.58346,5.67972 9.17564,6.08754 8.67564,6.08754 L8.67564,6.08744 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67564,17.34744 C8.17564,17.34744 7.76782,16.93962 7.76782,16.43962 L7.76782,12.17162 C7.76782,11.67162 8.17564,11.2638 8.67564,11.2638 C9.17564,11.2638 9.58346,11.67162 9.58346,12.17162 L9.58346,16.43962 C9.58346,16.93962 9.17564,17.34744 8.67564,17.34744 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08744,8.67564 C6.08744,9.17564 5.67962,9.58346 5.17962,9.58346 L0.90782,9.58346 C0.40782,9.58346 2.22044605e-13,9.17564 2.22044605e-13,8.67564 C2.22044605e-13,8.17564 0.40782,7.76782 0.90782,7.76782 L5.17582,7.76782 C5.67972,7.76782 6.08754,8.17172 6.08754,8.67564 L6.08744,8.67564 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.34744,8.67564 C17.34744,9.17564 16.93962,9.58346 16.43962,9.58346 L12.17162,9.58346 C11.67162,9.58346 11.2638,9.17564 11.2638,8.67564 C11.2638,8.17564 11.67162,7.76782 12.17162,7.76782 L16.43962,7.76782 C16.93962,7.76782 17.34744,8.17172 17.34744,8.67564 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84364,6.84364 C6.4874,7.19988 5.91552,7.19988 5.55926,6.84364 L2.53886,3.82324 C2.18262,3.467 2.18262,2.89512 2.53886,2.53886 C2.8951,2.1826 3.46698,2.18262 3.82324,2.53886 L6.84364,5.55926 C7.19988,5.9155 7.19988,6.4913 6.84364,6.84364 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.80764,14.80764 C14.4514,15.16388 13.87952,15.16388 13.52326,14.80764 L10.50286,11.78724 C10.14662,11.431 10.14662,10.85912 10.50286,10.50286 C10.8591,10.1466 11.43098,10.14662 11.78724,10.50286 L14.80764,13.52326 C15.15998,13.8795 15.15998,14.45138 14.80764,14.80764 L14.80764,14.80764 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.50384,6.84364 C10.86008,7.19988 11.43196,7.19988 11.78822,6.84364 L14.80862,3.82324 C15.16486,3.467 15.16486,2.89512 14.80862,2.53886 C14.45238,2.1826 13.8805,2.18262 13.52424,2.53886 L10.50384,5.55926 C10.1515,5.9155 10.1515,6.4913 10.50384,6.84364 L10.50384,6.84364 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.eb85a1d2793ada00b77e0ff2128fbee4.svg";
export { ForwardRef as ReactComponent };